import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
/**
 * @Description this page String Library's Trim Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Trim({
  action,
  variables,
  setOpenVariable,
  variableRender,
  setField,
  disabled,
  outputVisible
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const [trimBegin, setTrimBegin] = useState(false);
  const [trimEnd, setTrimEnd] = useState(false);

  //set first loaded default trim action value
  useEffect(() => {
    //if there is a trimBegin field when first loaded , set it
    if (action.fields?.trimBegin) {
      if (action.fields.trimBegin?.value !== false) {
        setTrimBegin(true);
      }
    }
    else {
      action.fields.trimBegin = { value: false }
    }
    //if there is a trimEnd field when first loaded , set it
    if (action.fields?.trimEnd) {
      if (action.fields.trimEnd?.value !== false) {
        setTrimEnd(true);
      }
    }
    else {
      action.fields.trimEnd = { value: false }
    }
  }, [action, variables])

  // if checked checkbox , set trim begin value
  function handleChangeBegin(event) {
    setTrimBegin(event.target.checked);

    //if unchecked , set field is a false
    if (!event.target.checked) {
      action.fields.trimBegin = false;
      setField('trimBegin', false);
    } else {
      action.fields.trimBegin = { value: "" };
      setField('trimBegin', { value: "" });
    }

  }
  // if checked checkbox , set trim end value
  function handleChangeEnd(event) {
    setTrimEnd(event.target.checked);

    //if unchecked , set field is a false
    if (!event.target.checked) {
      action.fields.trimEnd = false;
      setField('trimEnd', false);

    } else {
      action.fields.trimEnd = { value: "" };
      setField('trimEnd', { value: "" });

    }
  }

  return (
    <div>
      <div className="form-element">
        {t(label + "SOURCESTRING")}
        <TextInput
          action={action}
          inputName="sourceString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          disabled={disabled}
          displayName={t(label + "SOURCESTRING")}
          fieldType={"string"}
        />
      </div>
      <div className="form-element">
        <FormControlLabel
          control={
            <Checkbox
              checked={trimBegin}
              onChange={handleChangeBegin}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              name="checkedI"
              color="#C4C4C4"
            />
          }
          label={t(label + "TRIMBEGIN")}
        />
      </div>
      {trimBegin && (
        <div className="form-element">
          <TextInput
            action={action}
            inputName="trimBegin"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            setField={setField}
          />
        </div>
      )}
      <div className="form-element">
        <FormControlLabel
          control={
            <Checkbox
              checked={trimEnd}
              onChange={handleChangeEnd}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              name="checkedI"
              color="#C4C4C4"
            />
          }
          label={t(label + "TRIMEND")}
        />
      </div>

      {trimEnd && (
        <div className="form-element">
          <TextInput
            action={action}
            inputName="trimEnd"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            setField={setField}
          />
        </div>
      )}
      {
        !outputVisible && <div className="form-element">
          {t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")}
          <VariablePicker
            action={action}
            inputName="set"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            isRequired
            disabled={disabled}
          />
        </div>
      }
    </div>
  );
}
